import React, { useState, useEffect, useRef } from 'react';
import { axios } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export default function NotificationBell() {
  const [notifications, setNotifications] = useState([]);
  const [unread, setUnread]               = useState(0);
  const [open, setOpen]                   = useState(false);
  const ref = useRef();

  const [tick, setTick] = useState(0);

  const load = async () => {
    try {
      const { data } = await axios.get('/notifications');
      setNotifications(data.notifications);
      setUnread(parseInt(data.unread)||0);
    } catch {}
  };

  useEffect(() => {
    load();
    const t  = setInterval(load, 30000);
    const t2 = setInterval(() => setTick(x => x+1), 60000); // re-render every 60s to update "X min ago"
    return () => { clearInterval(t); clearInterval(t2); };
  }, []);

  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const markAllRead = async () => {
    try { await axios.put('/notifications/read-all'); setUnread(0); setNotifications(n=>n.map(x=>({...x,is_read:1}))); }
    catch {}
  };

  const deleteOne = async (id, e) => {
    e.stopPropagation();
    try {
      await axios.delete(`/notifications/${id}`);
      setNotifications(n => n.filter(x=>x.id!==id));
    } catch {}
  };

  const fmt = ts => {
    const diff = Date.now() - new Date(ts).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1)  return 'just now';
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24)  return `${hrs}h ago`;
    return `${Math.floor(hrs / 24)}d ago`;
  };

  return (
    <div ref={ref} style={{ position:'relative' }}>
      {/* Bell button */}
      <button onClick={()=>{ setOpen(!open); if(!open&&unread>0) markAllRead(); }}
        style={{ position:'relative', background:'rgba(255,255,255,0.18)', border:'1.5px solid rgba(255,255,255,0.4)', color:'white', width:40, height:40, borderRadius:12, cursor:'pointer', fontSize:'1.1rem', display:'flex', alignItems:'center', justifyContent:'center', transition:'all 0.2s' }}
        onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.3)'}
        onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.18)'}>
        🔔
        {unread > 0 && (
          <span style={{ position:'absolute', top:-5, right:-5, background:'#E53935', color:'white', borderRadius:99, width:18, height:18, fontSize:'0.6rem', fontWeight:800, display:'flex', alignItems:'center', justifyContent:'center', border:'2px solid white' }}>
            {unread > 9 ? '9+' : unread}
          </span>
        )}
      </button>

      {/* Dropdown */}
      {open && (
        <div style={{ position:'absolute', top:48, right:0, width:320, background:'white', borderRadius:18, boxShadow:'0 8px 40px rgba(0,0,0,0.18)', zIndex:999, overflow:'hidden', border:'1px solid rgba(255,107,0,0.12)' }}>
          {/* Header */}
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 16px', borderBottom:'1px solid rgba(255,107,0,0.1)', background:'linear-gradient(135deg,#FFF3E0,#FFE0B2)' }}>
            <div style={{ fontFamily:"'Baloo 2',sans-serif", fontWeight:700, color:'#BF360C', fontSize:'0.95rem' }}>
              🔔 Notifications
              {notifications.length > 0 && <span style={{ marginLeft:6, background:'#E55100', color:'white', borderRadius:99, padding:'1px 7px', fontSize:'0.65rem' }}>{notifications.length}</span>}
            </div>
            {notifications.length > 0 && (
              <button onClick={markAllRead} style={{ background:'none', border:'none', color:'#E55100', fontSize:'0.72rem', fontWeight:700, cursor:'pointer' }}>Mark all read</button>
            )}
          </div>

          {/* List */}
          <div style={{ maxHeight:380, overflowY:'auto' }}>
            {notifications.length === 0
              ? <div style={{ padding:32, textAlign:'center', color:'#9E6040' }}>
                  <div style={{ fontSize:'2rem', marginBottom:8 }}>🔕</div>
                  <div style={{ fontSize:'0.82rem', fontWeight:600 }}>No notifications yet</div>
                </div>
              : notifications.map(n => (
                <div key={n.id} style={{ display:'flex', gap:10, padding:'12px 14px', borderBottom:'1px solid rgba(0,0,0,0.04)', background:n.is_read?'white':'rgba(255,107,0,0.04)', transition:'background 0.2s', alignItems:'flex-start' }}>
                  <div style={{ width:34, height:34, borderRadius:10, background:n.type==='ADD'?'#E8F5E9':n.type==='EDIT'?'#E3F2FD':'#FFEBEE', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1rem', flexShrink:0 }}>
                    {n.type==='ADD'?'✅':n.type==='EDIT'?'✏️':'🗑️'}
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:'0.82rem', color:'#1A0A00', fontWeight:n.is_read?400:600, lineHeight:1.4 }}>{n.message}</div>
                    <div style={{ fontSize:'0.68rem', color:'#9E6040', marginTop:3 }}>🕐 {fmt(n.created_at)}</div>
                  </div>
                  <button onClick={e=>deleteOne(n.id,e)} style={{ background:'none', border:'none', color:'#ccc', cursor:'pointer', fontSize:'0.9rem', flexShrink:0, padding:'2px 4px' }}>✕</button>
                </div>
              ))
            }
          </div>
        </div>
      )}
    </div>
  );
}